import React from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

export function SiteAdditionalDetails({ details }) {
  const { about } = details;
  const {
    certifiedSiteStatus,
    specialtyFeatures = [],
    adjacentAvailableAcres,
    floodPlain,
  } = about;

  return (
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Additional Details</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="section-body">
        <ul>
          {(adjacentAvailableAcres !== null) &&
          <li><strong>Adjacent available acres: </strong>
            {adjacentAvailableAcres ? `Yes/${adjacentAvailableAcres}` : 'No'}
          </li>
          }
          {(floodPlain !== null && floodPlain !== '') && <li><strong>Flood plain: </strong>{floodPlain ? 'Yes' : 'No'}</li>}
          {(certifiedSiteStatus !== null && certifiedSiteStatus !== '') &&
          <li><strong>Certified: </strong>{certifiedSiteStatus ? 'Yes' : 'No'}</li>
          }
          {Array.isArray(specialtyFeatures) && specialtyFeatures.length > 0 && (
            <li><strong>Specialty Features: </strong>{specialtyFeatures.join(', ')}</li>
          )}
        </ul>
      </div>
    </section>
  );
}

SiteAdditionalDetails.propTypes = {
  details: PropTypes.object.isRequired,
};

export default SiteAdditionalDetails;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailAdditional/AdditionalDetails/SiteAdditionalDetails.js